export default class AccordionBlock {
    constructor(root) {
        this.root = root;
        this.cells = this.root.querySelectorAll('.js-accordion-block-cell');

        this.cells.forEach((cell) => {
            cell.addEventListener('click', (event) => {
                event.preventDefault();

                if(event.target.parentElement.classList.contains('--active')) {
                    event.target.parentElement.classList.remove('--active');
                } else {
                    event.target.parentElement.classList.add('--active');
                }
            });
        });
    }
}
